import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User } from 'src/app/shared/models/User';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getUserImage(): Observable<Blob> {
    return this.http.get('https://graph.microsoft.com/v1.0/me/photo/$value', {
      responseType: 'blob',
    });
  }

  getAllUsers(skipToken: string, top: number): Observable<User[]> {
    let url = '';
    if (skipToken != '') {
      url =
        environment.idpUserAdminAPI +
        '/listUsers?top=10&skipToken=' +
        skipToken;
    } else {
      url = environment.idpUserAdminAPI + '/listUsers?top=' + top;
    }
    return this.http.get<User[]>(url);
  }
}
